import Modal, { type ModalProps } from './Modal';

export default Modal;
export type { ModalProps };
